import ProductService from '../../../modules/product/productService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'PRODUCT_FORM'

const productFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: productFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await ProductService.find(id)
      }

      dispatch({
        type: productFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: productFormActions.INIT_ERROR,
      })

      dispatch(push('/product'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: productFormActions.CREATE_STARTED,
      })

      await ProductService.create(values)

      dispatch({
        type: productFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.product.create.success'),
      )

      dispatch(push('/product'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: productFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: productFormActions.UPDATE_STARTED,
      })

      await ProductService.update(id, values)

      dispatch({
        type: productFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.product.update.success'),
      )

      dispatch(push('/product'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: productFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default productFormActions
